import { css } from 'styled-components';

export const antdRangePicker = css(
  ({ theme }) => `
    .ant-picker-range-wrapper {
      .ant-picker-body {
        border-top: 0;
        padding: 15px 12px;
      }
      .ant-calendar-input:hover,
      .ant-calendar-time-picker-input:hover {
        border-color: ${theme.baseBlue.a10};
      }

      .ant-calendar-input:focus,
      .ant-calendar-time-picker-input:focus {
        border-color: ${theme.baseBlue.a10};
      }

      .ant-picker-cell-in-range,
      .ant-picker-cell-range-hover,
      .ant-picker-cell-in-view.ant-picker-cell-in-range.ant-picker-cell-range-hover {
        .ant-picker-cell-inner {
          color: ${theme.white.a6};
          &:hover {
            color: ${theme.white.a10};
          }
        }
      }

      .ant-picker-cell-in-view.ant-picker-cell-in-range.ant-picker-cell-range-hover-end,
      .ant-picker-cell-range-hover-edge-end {
        border-color: ${theme.baseBlue.a10};
        color: ${theme.white.a6};
        .ant-picker-cell-inner::after {
          background: unset;
        }
        &:hover {
          background: ${theme.baseBlue.a10};
          color: ${theme.white.a10};
        }
      }

      .ant-picker-cell-in-view.ant-picker-cell-in-range.ant-picker-cell-range-hover-start {
        border-color: ${theme.baseBlue.a10};
        color: ${theme.white.a6};
        .ant-picker-cell-inner::after {
          background: unset;
        }
        &:hover {
          background: ${theme.baseBlue.a10};
          color: ${theme.white.a10};
        }
      }

      .ant-picker-cell-in-view.ant-picker-cell-range-hover:not(.ant-picker-cell-in-range)::after {
        border: none
      }
    }
`,
);
